import { AxiosProgressEvent } from 'axios';

export function createProgressHandler(
  onProgress?: (loaded: number, total: number) => void
): ((event: AxiosProgressEvent) => void) | undefined {
  if (!onProgress) {
    return undefined;
  }

  return (event: AxiosProgressEvent) => {
    if (event.loaded != null && event.total != null && event.total > 0) {
      onProgress(event.loaded, event.total);
    }
  };
}
